/**
 * Specifies the type of date (e.g. adjusted for holidays).
 * tag: 40173
 * @readonly
 * @enum {number} (int)
 */
export enum ProvisionCashSettlPaymentDateType {
  /** Unadjusted */
  Unadjusted = 0,
  /** Adjusted */
  Adjusted = 1,
}
